module.exports = {"incident":{"identifiers":["IncidentName","UniqueFireIdentifier","FireCode","ABCDMisc","IrwinID"],"sync":["CreatedBySystem","CreatedOnDateTime","ModifiedBySystem","ModifiedOnDateTime"],"relationshipLabels":{"complex":"Is in a Complex","merge":"Is Merged","conflict":"Potential Conflict","quarantine":"Is Quarantined","providingresponse":"Providing Response","prescribedescape":"Prescribed Fire Escape","postfire":"Post Fire"},"statsLabels":{"totalUpdates":"Total Updates","modifiedBySystems":"Participating Systems"}}}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/DetailsCard.json
// module id = 1680
// module chunks = 0